module.exports = __webpack_public_path__ + "img/1_033.f88ada64.jpg";